<template>
  <div class="no-permission">
    <div class="empty-tip">
      <i class="icon-img"></i>
      <p class="tip">抱歉，没有权限访问哦！</p>
      <a-button type="primary" @click="$router.push('/');">回到首页</a-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoPermission', // 巡视备注组件

  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style>
#app{
  height: 100%;
}
</style>
<style lang="scss" scoped>
  .no-permission{
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    .empty-tip{
      display: flex;
      flex-direction: column;
    }
    .icon-img{
      display: block;
      width: 100px;
      height: 100px;
      background-image: url('~@/assets/img/guideStation/empty-box@2x.png');
      background-repeat: no-repeat;
      background-size: cover;
      margin: 0 auto 10px;
    }
    .tip{
      margin-bottom: 20px;
    }
  }
</style>